import React from "react";
import { TranslationService } from "../../services/TranslationService";

const ErrorBoundaryPreview = () => {
  const handleGoToDashboard = () => {
    const currentLanguage = TranslationService.currentLanguage;
    window.location.href = `/${currentLanguage}/company`;
  };

  const handleRefresh = () => {
    // En el preview, no recargamos realmente, solo mostramos
    console.log("Refresh button clicked");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
        padding: "20px",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
      }}
    >
      <div
        style={{
          maxWidth: "600px",
          width: "100%",
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow:
            "0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
          padding: "40px",
          textAlign: "center"
        }}
      >
        {/* Icono de warning */}
        <div
          style={{
            fontSize: "48px",
            marginBottom: "24px",
            color: "#ffc107",
            animation: "errorIconAnimation 2s ease-in-out infinite",
            display: "inline-block"
          }}
        >
          <i className="fas fa-exclamation-circle"></i>
        </div>

        {/* Estilos de animación */}
        <style>{`
          @keyframes errorIconAnimation {
            0%, 100% {
              transform: scale(1) translateY(0) rotate(0deg);
              opacity: 1;
            }
            25% {
              transform: scale(1.1) translateY(-8px) rotate(-5deg);
              opacity: 0.95;
            }
            50% {
              transform: scale(1.15) translateY(-10px) rotate(0deg);
              opacity: 0.9;
            }
            75% {
              transform: scale(1.1) translateY(-8px) rotate(5deg);
              opacity: 0.95;
            }
          }
        `}</style>

        {/* Título */}
        <h1
          style={{
            fontSize: "28px",
            fontWeight: "600",
            color: "#212529",
            marginBottom: "16px",
            marginTop: "0"
          }}
        >
          {TranslationService.translate.ErrorProcessingRequest ||
            "We detected a problem"}
        </h1>

        {/* Mensaje descriptivo */}
        <p
          style={{
            fontSize: "16px",
            color: "#6c757d",
            marginBottom: "32px",
            lineHeight: "1.6"
          }}
        >
          {TranslationService.translate.ErrorBoundaryMessage ||
            "The error has been reported. Our team of specialists will be working to resolve it as soon as possible!"}
        </p>

        {/* Botones de acción */}
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "center",
            flexWrap: "wrap"
          }}
        >
          <button
            onClick={handleRefresh}
            style={{
              backgroundColor: "#28a745",
              color: "white",
              border: "none",
              borderRadius: "8px",
              padding: "12px 32px",
              fontSize: "16px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.2s ease",
              boxShadow: "0 2px 4px rgba(40, 167, 69, 0.3)",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px"
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#218838";
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow =
                "0 4px 8px rgba(40, 167, 69, 0.4)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#28a745";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 2px 4px rgba(40, 167, 69, 0.3)";
            }}
          >
            <i className="fas fa-sync-alt" style={{ fontSize: "14px" }}></i>
            {TranslationService.translate.Refresh || "Refresh"}
          </button>
          <button
            onClick={handleGoToDashboard}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "8px",
              padding: "12px 32px",
              fontSize: "16px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.2s ease",
              boxShadow: "0 2px 4px rgba(0, 123, 255, 0.3)",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px"
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#0056b3";
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow =
                "0 4px 8px rgba(0, 123, 255, 0.4)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#007bff";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 2px 4px rgba(0, 123, 255, 0.3)";
            }}
          >
            <i className="fas fa-home" style={{ fontSize: "14px" }}></i>
            {TranslationService.translate.BackToDashboard}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundaryPreview;
